/* shared config for nav */
export const config = {
  navigationOpenModifierClass: 'navigation--state-open',
  navigationClosedModifierClass: 'navigation--state-closed',
  imageHoverPlaceholderSelector: '.js-navigation-hover-image-placeholder',
  hoverCaptionPlaceholderSelector: '.js-navigation-hover-caption-placeholder',
  commonNavigationSelector: '.js-navigation',
  header: '.js-header',
  main: '.js-main',
  footer: '.js-footer',
  darkOverlaySelector: '.js-navigation-overlay',
  body: 'body',
  bodyLockScrollClass: 'body--state-scroll-lock',
  headerPrimaryLevelSelector: '.js-header-primary-level',
  headerSecondaryLevelSelector: '.js-header-secondary-level',
  headerLevelFadeClass: 'header__navigation-wrap--state-fade',
  headerLevelHideClass: 'header__navigation-wrap--state-hidden',
};
